"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SubmissionStatus = void 0;
var _SubmissionStrategies;
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SubmissionStatus = exports.SubmissionStatus = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  DETAILED_ERROR: 'DETAILED_ERROR',
  UNSUBMITTED: 'UNSUBMITTED',
  DEFAULT: 'DEFAULT'
};
var successTransformer = function successTransformer(_, _ref) {
  var feedbackMessage = _ref.payload;
  return {
    showSnackbar: true,
    isSuccess: true,
    feedbackMessage: feedbackMessage
  };
};
var errorTransformer = function errorTransformer(_, _ref2) {
  var feedbackMessage = _ref2.payload;
  return {
    showSnackbar: true,
    isSuccess: false,
    feedbackMessage: feedbackMessage
  };
};
var detailedErrorTransformer = function detailedErrorTransformer(state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    detailedErrorOpen: true
  });
};
var unsubmittedTransformer = function unsubmittedTransformer(state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isSuccess: false,
    detailedErrorOpen: false,
    showSnackbar: false
  });
};
var SubmissionStrategies = (_SubmissionStrategies = {}, _defineProperty(_SubmissionStrategies, SubmissionStatus.SUCCESS, successTransformer), _defineProperty(_SubmissionStrategies, SubmissionStatus.ERROR, errorTransformer), _defineProperty(_SubmissionStrategies, SubmissionStatus.DETAILED_ERROR, detailedErrorTransformer), _defineProperty(_SubmissionStrategies, SubmissionStatus.UNSUBMITTED, unsubmittedTransformer), _defineProperty(_SubmissionStrategies, SubmissionStatus.DEFAULT, function (state) {
  return state;
}), _SubmissionStrategies);
var reducer = function reducer(state, action) {
  var _SubmissionStrategies2;
  var transformer = (_SubmissionStrategies2 = SubmissionStrategies[action.type]) !== null && _SubmissionStrategies2 !== void 0 ? _SubmissionStrategies2 : SubmissionStrategies.DEFAULT;
  return transformer(state, action);
};
var _default = exports["default"] = reducer;